import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Heading from "../../../../../../components/theme/text/Heading";
import Text from "../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../theme";

// import Echeck from "./views/Echeck";

import MSelectWarehouses from "../../../../../../components/global/Modals/MSelectWarehouses";
import TabView3 from "../../../../../../components/theme/TabView3/TabView3";
import { settingsWarehousePickingResourcedConfig } from "./settingsWarehousePickingResourcedConfig";
import PickingCarts from "./views/PickingCarts";
import PickingCrates from "./views/PickingCrates";
import Containersizes from "./views/Containersizes";
import { useTranslation } from 'react-i18next';
import { useTopbar } from '../../../../../../contexts/TopbarProvider';

const Resources = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {showExtraTitle,clearExtraTitle } = useTopbar();
    

    const [open, setOpen] = useState(false);
    const warehouseModal = {
        open: open,
        setOpen: setOpen
    }

    const [addStandardOpen, setAddStandardOpen] = useState(false);
    const addStandardModal = {
        open: addStandardOpen,
        setOpen: setAddStandardOpen
    }

    useEffect(() => {
        showExtraTitle(t("resources"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box 
            sx={{
                background:"", 
                width:1,
                paddingTop:9,
                position:"relative",
                "@media screen and (max-width:47.9375em)" : {
                        background:"", 
                    width:1,
                    marginTop:9,
                    height: "calc(100% - 72px)",
                    // position:"relative",
                    paddingX:4,
                    paddingTop:0,
                    overflow:"hidden",
                    display:"flex",
                    flexDirection:"column",
                    
                },
                "@media screen and (max-width: 47.9375em)" : {
                    paddingX:0,
                    background:colors.bg["tertiary"],
                    "&:before,&:after":{
                        display:"none"
                    }
                },
            }}
        >


                    
            <TabView3
                tabConfig={settingsWarehousePickingResourcedConfig}
                // viewType="bodytabs"
                sx={{

                    background:"green",
                    minHeight:"calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,
                    display:"flex",
                    flexDirection:"column",
                    // "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },
                        "@media screen and (max-width: 47.9375em)" : {

                            "&:before, &:after" : {
                                top:0,
                            }
                        }
                    // }
                  
                }}
                // title={panel.title}
                // views={panel.views}
                // tabClasses={"btn-body-tab"}
            >
                <>
                    <PickingCarts config={settingsWarehousePickingResourcedConfig.pickupcarts}  warehouseModal={warehouseModal}/>
                    <PickingCrates config={settingsWarehousePickingResourcedConfig.pickupcrates} warehouseModal={warehouseModal}/>
                    <Containersizes config={settingsWarehousePickingResourcedConfig.containersizes} warehouseModal={warehouseModal}/>
                    {/* <Standard apiRef={standardCarriersApiRef}/>
                    <Materials apiRef={materialsApiRef}/> */}
                </>
            </TabView3>

            <MSelectWarehouses
                open={warehouseModal.open}
                handleClose={() => warehouseModal.setOpen(false)}
            />

        </Box>
    )
}

export default Resources;